import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'
import ImageHero from 'app/theme/ImageHero'
import NavbarFixed from 'app/theme/NavbarFixed'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import Calculator from 'app/theme/calculator'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'
import heroImage from 'assets/img/hospital-week-hero.jpg'
import hospitalWeek1 from 'assets/img/cal-medical-association-2.jpg'
import hospitalWeek2 from 'assets/img/cal-medical-association-1.jpg'
import hospitalWeek3 from 'assets/img/hospital-week-3.jpg'
import hospitalWeek4 from 'assets/img/hospital-week-4.jpg'
import { useModalState } from 'lib/modal'
import LeadModal from 'app/leads/LeadModal'

export default function HospitalWeekPage(props) {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    initialInView: true,
    rootMargin: '1px',
  })

  const {
    title = 'Hospital Week 2021',
    description = "This year Hospital Week falls from May 2-8, and we think the best way to celebrate is with amazing food. With our national network of over 23,000 food trucks, we'll help you celebrate the local doctors, nurses, and staff that make our communities healthy.",
  } = props

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>
          Hospital Week - Food Trucks
        </title>
        <meta
          name="description"
          content="Appreciate your employees by bringing out food trucks to Hospital Week."
        />
        <meta
          name="og:title"
          content="Hospital Week - Food Trucks"
        />
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImage}
          title={title}
          description={description}
          onButtonClick={openModal}
        />
      </div>
      {!inView && (
        <NavbarFixed onButtonClick={openModal} />
      )}
      <OccasionPageGrid className="mt-12">
        <OccasionPageGridRow
          heading="Something for Everyone"
          content="Keep your doctors, nurses and staff well fed. With a network of over 23,000 food trucks, we secure a variety of food options no matter where you work. From lobster rolls, to tacos or gourmet salads, we ensure a delicious mix designed to make everyone happy."
          image={hospitalWeek1}
          reverse
        />
        <OccasionPageGridRow
          heading="Celebrate Your Hardworking Staff"
          content="Give the whole hospital staff a reason to bond. We bring food trucks to Hospital Week, the perfect way to make Doctors, Nurses, Admins and Staff feel appreciated. You'll be a food truck hero!"
          image={hospitalWeek2}
        />
      </OccasionPageGrid>
      <WhyWorkWithUs
        onButtonClick={openModal}
      />
      <HowItWorks
        heading="How Hospital Week Catering Works"
        onButtonClick={openModal}
        hiddenLg={false}
      />
      <OccasionPageGrid className="mt-12 mb-12">
        <OccasionPageGridRow
          heading="Service Guarantee"
          content="Book catering for Hospital Week with confidence knowing we have established relationships with the food trucks. We hold all funds until after your event, so we can guarantee you'll get fantastic customer service every time."
          image={hospitalWeek3}
          reverse
        />
        <OccasionPageGridRow
          heading="You're Completely Covered"
          content="Get back to doing more important things. Experience our seamless booking with a single point of contact and your catering preferences on file. We handle all the logistics, whether you plan to book food trucks just for Hospital Week or over and over again."
          image={hospitalWeek4}
        />
      </OccasionPageGrid>
      <FeaturedClients
        onButtonClick={openModal}
      />
      <Calculator
        onButtonClick={openModal}
      />
    </Layout>
  )
}
